import { useEffect, useRef, useState } from 'react'
import hipersendService from '../../../services/hipersend'
import { templatesAprovados, nomeDoTemplate } from '../../../libs/metaTemplates'

// Modelos que podem sair num envio em massa: os aprovados pela Meta, em
// qualquer idioma — o envio sai no idioma em que o modelo está instalado.
// Usado pelo seletor do agendamento e pela escolha de modelo do disparo.
//
// O mesmo nome pode existir em dois idiomas (sync que adotou modelos criados
// direto na Meta). O envio usa o aprovado mais recente, então o seletor mostra
// o nome uma vez só, com esse registro — senão as variáveis poderiam vir do
// registro errado.
function umPorNome(lista) {
  const ordenados = [...lista].sort((a, b) => new Date(b?.updated_at || 0) - new Date(a?.updated_at || 0))
  const vistos = new Set()
  const saida = []
  for (const t of ordenados) {
    const nome = nomeDoTemplate(t)
    if (vistos.has(nome)) continue
    vistos.add(nome)
    saida.push(t)
  }
  // devolve na ordem original da resposta, só sem as repetições
  return lista.filter((t) => saida.includes(t))
}
//
// `onCarregou(modelos)` roda uma vez, quando a lista chega — o agendamento
// usa para reabrir o modelo que estava salvo.
export default function useModelosAprovados(api, secret, { onCarregou } = {}) {
  const [modelos, setModelos] = useState([])
  const [carregando, setCarregando] = useState(false)
  const [erro, setErro] = useState('')
  const avisar = useRef(onCarregou)
  avisar.current = onCarregou

  useEffect(() => {
    if (!api || !secret) return undefined
    let vivo = true

    setCarregando(true)
    setErro('')
    hipersendService.metaTemplates
      .list(api, secret)
      .then((resposta) => {
        if (!vivo) return
        const aprovados = umPorNome(templatesAprovados(resposta))
        setModelos(aprovados)
        if (avisar.current) avisar.current(aprovados)
      })
      .catch(() => { if (vivo) setErro('Não foi possível carregar os modelos aprovados') })
      .finally(() => { if (vivo) setCarregando(false) })

    return () => { vivo = false }
  }, [api, secret])

  return { modelos, carregando, erro }
}
